import { Component, OnInit, Input } from "@angular/core";
import { FormControl, ValidationErrors, Validators } from "@angular/forms";
import {
  debounceTime,
  tap,
  switchMap,
  finalize,
  distinctUntilChanged,
  map,
} from "rxjs/operators";
import { SystemSettingsService } from "services";
import { of } from "rxjs";

@Component({
  selector: "app-search-ulb",
  templateUrl: "./search-ulb.component.html",
})
export class SearchUlbComponent implements OnInit {
  @Input() label: string;
  @Input() name: FormControl;
  @Input() code: FormControl;
  @Input() otherUlb: any = null;
  options = [];
  isLoading = false;

  private requireMatch(control: FormControl): ValidationErrors | null {
    const selection: any = control.value;
    if (
      control.value?.length &&
      this.options &&
      this.options.map((x) => x.name).indexOf(selection) < 0
    ) {
      return { requireMatch: true };
    }
    this.code.setValue(this.options.find((x) => x.name === selection)?.code);
    return null;
  }

  constructor(private sys: SystemSettingsService) {}

  ngOnInit(): void {
    this.name.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .pipe(
        tap(() => {
          // this.options = [];
          this.isLoading = true;
          this.name.setValidators(this.requireMatch.bind(this));
        }),
        switchMap((value: string) => {
          let ulbcode = [];
          let data;
          if (this.otherUlb?.length) {
            this.otherUlb.controls.forEach((u1) => {
              ulbcode.push(u1.value.ulbId);
            });
            data = {
              code: ulbcode.join().replace(/,\s*$/, ""),
            };
          } else {
            data = {};
          }
          return value && value?.length > 1
            ? this.sys.getOtherUlb(value, data).pipe(
                finalize(() => {
                  this.isLoading = false;
                })
              )
            : of(null).pipe(
                finalize(() => {
                  this.isLoading = false;
                })
              );
        })
      )
      .subscribe((res) => {
        if (res && res.data?.length) {
          this.options = res.data;
        }
      });
  }
}
